import {
    CREATE_GENERAL_PO_DETAILS_REQUEST_DK,
    CREATE_GENERAL_PO_DETAILS_SUCCESS_DK,
    CREATE_GENERAL_PO_DETAILS_FAILURE_DK,
    DELETE_GENERAL_PO_DETAILS_REQUEST_DK,
    DELETE_GENERAL_PO_DETAILS_SUCCESS_DK,
    DELETE_GENERAL_PO_DETAILS_FAILURE_DK,
    FETCH_SINGLE_GENERAL_PO_DETAILS_REQUEST_DK,
    FETCH_SINGLE_GENERAL_PO_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_GENERAL_PO_DETAILS_FAILURE_DK,
    FETCH_GENERAL_PO_DETAILS_REQUEST_DK,
    FETCH_GENERAL_PO_DETAILS_SUCCESS_DK,
    FETCH_GENERAL_PO_DETAILS_FAILURE_DK,
    UPDATE_GENERAL_PO_DETAILS_REQUEST_DK,
    UPDATE_GENERAL_PO_DETAILS_SUCCESS_DK,
    UPDATE_GENERAL_PO_DETAILS_FAILURE_DK,
    RESET_GENERAL_PO_DETAILS_INFO_DK,
    CREATE_GENERAL_PO_DETAILS_FORM_DK,
    UPDATE_GENERAL_PO_DETAILS_FORM_DK,
    FETCH_GENERAL_PO_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_GENERAL_PO_DETAILS_GROUP_LIST_REQUEST_DK,
    FETCH_GENERAL_PO_DETAILS_GROUP_LIST_SUCCESS_DK,
    FETCH_GENERAL_PO_PREVIOUS_LIST_REQUEST_DK,
    FETCH_GENERAL_PO_PREVIOUS_LIST_FAILURE_DK,
    FETCH_GENERAL_PO_PREVIOUS_LIST_SUCCESS_DK,
   
} from './generalPoDetails.actionsType';

export const GENERAL_PO_DETAILS_DK = 'generalPoDetailsDK';

let initialState = {
    loading: false,
    generalPoDetails: [],
    generalPoDetailsWithoutId: [],
    groupList: [],
    generalPoDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    previousList: [],
    selectedState: {},
    errorMessage: ''
};

export let generalPoDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_GENERAL_PO_DETAILS_REQUEST_DK:
        case CREATE_GENERAL_PO_DETAILS_REQUEST_DK:
        case UPDATE_GENERAL_PO_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_GENERAL_PO_DETAILS_REQUEST_DK:
        case DELETE_GENERAL_PO_DETAILS_REQUEST_DK:
        case FETCH_GENERAL_PO_PREVIOUS_LIST_REQUEST_DK:
        case FETCH_GENERAL_PO_DETAILS_GROUP_LIST_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoDetails: updatePayload
            };
        
        case FETCH_GENERAL_PO_PREVIOUS_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_GENERAL_PO_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoDetailsWithoutId: updatePayload
            };
        case FETCH_GENERAL_PO_DETAILS_GROUP_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                groupList: updatePayload
            };
        case CREATE_GENERAL_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                grnNoByGeneralPO:[]
            };
        case UPDATE_GENERAL_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_GENERAL_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: updatePayload
            };
        case DELETE_GENERAL_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case RESET_GENERAL_PO_DETAILS_INFO_DK:
            return {
                ...state,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case CREATE_GENERAL_PO_DETAILS_FORM_DK:
        case UPDATE_GENERAL_PO_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    ...state.generalPoDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_GENERAL_PO_DETAILS_FAILURE_DK:
        case CREATE_GENERAL_PO_DETAILS_FAILURE_DK:
        case UPDATE_GENERAL_PO_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_GENERAL_PO_DETAILS_FAILURE_DK:
        case DELETE_GENERAL_PO_DETAILS_FAILURE_DK:
        case FETCH_GENERAL_PO_PREVIOUS_LIST_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
